import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import HttpBase from '../models/httpBase';
import EnvironmentService from '../services/environmentService';
import Invoice from '../models/invoice';

@Injectable()
export default class InvoiceService extends HttpBase {

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  getInvoice(invoiceNumber: string, startDate: string, endDate: string) {

    const queryString = `invoiceNumber=${invoiceNumber}&startDate=${startDate}&endDate=${endDate}`;
    return this.httpGet(`${this.environmentService.invoiceUrl}?${queryString}`)
    .map((r: Response) => {
      return Invoice.createFromRequest(r.json());
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/invoiceService.ts